import React, { useEffect } from "react";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

const AppCapisSource = ({ form, appCapi, setAppCapi, fileError, setFileError }) => {
  const language = useSelector((state) => state.languagesState.languages);
  
  const handleAndroidChange = (e) => {
    setAppCapi({ appCapiName: e.target.value });
    if (fileError && e.target.value !== "") {
      setFileError("");
    }
  };

  useEffect(() => {
    setAppCapi({
      appCapiName: "",
    });
    setFileError("");
  }, [form.source_type]);

  return (
    <div>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <FormControl style={{width: '100%'}} error={fileError}>
          <TextField
            label={language?.source_modal?.package_name ?? "Package Name"}
            variant="outlined"
            onChange={handleAndroidChange}
            placeholder={language?.source_modal?.package_name ?? "Package Name"}
            error={fileError}
            inputProps={{ "data-cy": "create-source-package-name" }}
          />
          {fileError && <div className="fileUploadStyle">{fileError}</div>}
        </FormControl>
      </Form.Group>
    </div>
  );
};

export default AppCapisSource;
